class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      // Update free shipping progress bar if it exists
      if (this.notification.querySelector('.cart-buttons-and-shipping-bar')) {
        this.updateFreeShippingProgressBar();
      }
      this.open();
  }

  async updateFreeShippingProgressBar() {
    try {
      // Fetch the cart page with nolayout view
      const url = '/cart?view=nolayout';
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = await response.text();
      // Parse the returned HTML and extract the new progress bar
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newBar = tempDiv.querySelector('#free-shipping-progress-bar');
      // Only update inside the notification
      const notification = this.notification;
      if (newBar && notification) {
        const oldBars = notification.querySelectorAll('.free-shipping-progress-bar');
        if (oldBars.length > 0) {
          oldBars.forEach(function(oldBar) {
            oldBar.replaceWith(newBar.cloneNode(true));
          });
        }
        // The fetched markup reflects the delivery_preference cart attribute, which is written
        // asynchronously and can lag the customer's choice. Re-stamp from localStorage.
        if (window.ShippingProgressVisibility) window.ShippingProgressVisibility.apply();
      }
    } catch (e) {
      // Silently fail
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
